export default [
  {
    path: "/creditscore",
    component: () => import("@/views/creditscore/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/creditscore/home"),
        meta: {
          title: "我的信用分"
        }
      },
  
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/creditscore.js